(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/teams.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/teams.js');
'use strict';

const {
  useHistory
} = ReactRouterDOM;
const {
  activationHandler
} = svs.arena.pages.teams;
const {
  hooks
} = svs.arena.shared;
const {
  ErrorMessage
} = svs.arena.shared.components;
const {
  TeamsOverview
} = svs.arena.pages.teams.components;
const {
  fetchTeams,
  setTeamBalance,
  fetchCustomerId
} = svs.arena.store.teams.actions;
const {
  routes,
  depositType,
  returnStatus
} = svs.arena.constants;
const {
  submitDeposit,
  submitInviteDeposit,
  submitCreateDeposit
} = svs.arena.shared.deposit.doDeposit;
const Teams = () => {
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const {
    data: teams,
    error
  } = hooks.useTeams(60);
  const teamDetails = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.teamDetails;
  });
  const [triggerActions, setTriggerActions] = React.useState(true);
  const handleFetchTeams = () => {
    dispatch(fetchTeams());
  };
  const depositLocalStorageHandler = async (data, err) => {
    if (data && !err && data.syndicateId) {
      var _depositData;
      let depositData;
      if (parseInt(data.amount, 10) > 0) {
        switch (data.depositType) {
          case depositType.INVITE:
            depositData = await submitInviteDeposit(data.amount, data.syndicateId);
            break;
          case depositType.CREATE:
            depositData = await submitCreateDeposit(data.amount, data.syndicateId);
            break;
          default:
            depositData = await submitDeposit(data.amount, data.syndicateId);
            break;
        }
      }
      if (((_depositData = depositData) === null || _depositData === void 0 ? void 0 : _depositData.status) === returnStatus.SUCCESS) {
        dispatch(setTeamBalance({
          teamId: data.syndicateId,
          memberBalance: depositData.memberBalance,
          syndicateBalance: depositData.syndicateBalance,
          playableAmount: depositData.playableAmount
        }));
      }
      if (depositData) {
        svs.components.Storage.browser.remove('syndicateDepositAmount', 'syndicate');
      }
    }
  };
  React.useEffect(() => {
    var _svs$components;
    dispatch(fetchCustomerId());
    (_svs$components = svs.components) === null || _svs$components === void 0 || (_svs$components = _svs$components.Storage) === null || _svs$components === void 0 || _svs$components.browser.get('syndicateDepositAmount', 'syndicate', async (data, err) => {
      await depositLocalStorageHandler(data, err);
    });
  }, []);

  React.useEffect(() => {
    if (triggerActions && (teamDetails === null || teamDetails === void 0 ? void 0 : teamDetails.length) > 0) {
      setTriggerActions(false);
      if (teams !== null && teams !== void 0 && teams.some(specificTeam => (specificTeam === null || specificTeam === void 0 ? void 0 : specificTeam.isLeader) === true)) {
        activationHandler(dispatch);
      }
    }
  }, [teamDetails]);
  return React.createElement(React.Fragment, null, error && React.createElement(ErrorMessage, {
    actions: [{
      handleClick: handleFetchTeams,
      text: 'Försök igen'
    }],
    header: "Tillf\xE4lligt fel!",
    icon: "exclamation-sign",
    text: "N\xE5gonting gick fel n\xE4r dina lag skulle visas upp. F\xF6rs\xF6k igen om en stund."
  }), (teams === null || teams === void 0 ? void 0 : teams.length) > 0 && !error && React.createElement(TeamsOverview, {
    teams: teams
  }), (teams === null || teams === void 0 ? void 0 : teams.length) <= 0 && !error && history.push(routes.TEAMS_CREATE));
};
svs.arena.pages.teams.Teams = Teams;

 })(window);